$('body').on('click', '.new-application .select-session', function() {
	var $this = $(this);
	var card = $this.parents('.card');
    if($this.hasClass('closed')) {
    	return false;
    }

    $('.new-application .select-session').removeClass('active');
    $this.addClass('active');

    $('.card[data-card="'+card.attr('data-next')+'"]').removeClass('disabled');
    $('html, body').animate({
        scrollTop: $('.card[data-card="'+card.attr('data-next')+'"]').offset().top - 140
    }, 300);
    return false;
});

// when clicking on agree to terms
$('body').on('click', '.agree-to-terms', function() {
    var $this = $(this);
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please agree to all required terms');
        return false;
    }

    // go to the next step
    card.find('.apply-signature').removeClass('hidden');
    $('.card[data-card="'+card.attr('data-next')+'"]').removeClass('disabled');
    $('html, body').animate({
        scrollTop: $('.card[data-card="'+card.attr('data-next')+'"]').offset().top - 140
    }, 300);
    return false;
});

$('body').on('change', '.new-application select[name="shirt_size"]', function() {
    var $this = $(this);
    var card = $this.parents('.card');
    $('.card[data-card="'+card.attr('data-next')+'"]').removeClass('disabled');
    $('html, body').animate({
        scrollTop: $('.card[data-card="'+card.attr('data-next')+'"]').offset().top - 140
    }, 300);
    return false;
});

$('body').on('change', '.new-application [name="to_location"], .new-application [name="from_location"]', function () {
    var $this = $(this);

    if (!$('.new-application [name="to_location"]:checked').val() || !$('.new-application [name="from_location"]:checked').val()) {
        return false;
    }

    var card = $this.parents('.card');
    $('.card[data-card="' + card.attr('data-next') + '"]').removeClass('disabled');
    $('html, body').animate({
        scrollTop: $('.card[data-card="' + card.attr('data-next') + '"]').offset().top - 140
    }, 300);
    return false;
});

$('body').on('click', '.new-application .select-scholarship', function() {
	var $this = $(this);
	var card = $this.parents('.card');
    if($this.hasClass('closed')) {
    	return false;
    }

    $('.new-application .select-scholarship').removeClass('active');

    switch($this.attr('data-scholarship')) {
    	case 'apply':
    	case 'skip':
    	case 'later':
		    $this.addClass('active');
		    $('.card[data-card="'+card.attr('data-next')+'"]').removeClass('disabled');
		    $('html, body').animate({
		        scrollTop: $('.card[data-card="'+card.attr('data-next')+'"]').offset().top - 140
		    }, 300);
    		break;

    	case 'request':
    		$this.addClass('active');
    		toggleCardView(card, 'request');
    		break;
    }

    return false;
});

$('body').on('change', '.add-scholarships-from-application [name="mode"]', function() {
    var $this = $(this);
    
    $('.add-scholarships-from-application .mode').removeClass('active');
    $('input, select', '.add-scholarships-from-application .mode').removeClass('required');

    $('.add-scholarships-from-application .mode[data-mode="'+$this.val()+'"]').addClass('active');
    $('input, select', '.add-scholarships-from-application .mode[data-mode="' + $this.val() + '"]').addClass('required');

});

$('body').on('submit', '.add-scholarships-from-application form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.error').removeClass('error');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
            input.addClass('error');
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
	            showError('Error', data.message);
	            return false;
            }

            $('.add-scholarships-from-application').remove();
            $('.select-scholarship-wrapper').html(`<a href="" class="select-scholarship active" data-scholarship="apply">
				<h3>Apply Scholarship</h3>
			</a>`);
            toggleCardView(card, 'details');

			$('.card[data-card="'+card.attr('data-next')+'"]').removeClass('disabled');
		    $('html, body').animate({
		        scrollTop: $('.card[data-card="'+card.attr('data-next')+'"]').offset().top - 140
		    }, 300);

        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});

$('body').on('click', '.select-submission', function() {
    var $this = $(this);
    
    loading();
    $.ajax({
        type : 'POST',
        url : $('.new-application').attr('data-action'),
        data : {
        	'_token': $('meta[name="csrf-token"]').attr('content'),
            'session': $('.new-application .select-session.active').attr('data-session'),
            'shirt_size': $('[name="shirt_size"]').length ? $('[name="shirt_size"]').val() : '',
            'to_location': $('[name="to_location"]:checked').length ? $('[name="to_location"]:checked').val() : '',
            'from_location': $('[name="from_location"]:checked').length ? $('[name="from_location"]:checked').val() : '',
            'scholarship': $('.new-application .select-scholarship.active').attr('data-scholarship')
        },
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
	            showError('Error', data.message);
	            return false;
            }

            window.location.href = $this.attr('data-submission') === 'add-child' ? 'children' : 'new-application/payment';
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });
    return false;
});


var bunkRequest = `<div class="request">
    <a href="" class="remove-bunk-request-trigger icon-delete" tabindex="-1"></a>

    <ul class="fields no-padding">
        <li class="">
            <input type="text" name="bunk_request[]" class="required focus tab-next">
            <span>Bunk Request</span>
        </li>
    </ul>
</div>`;

$('body').on('click', '.bunk-request .add-bunk-request-trigger', function() {
    var $this = $(this);
    var card = $this.parents('.bunk-request');
    var limit = parseInt(card.attr('data-limit'));
    console.log(limit);
    
    if(card.find('.request').length == limit) {
        // if they already have the limit return false
        return false;
    }

    card.find('.setup-bunk-requests').append(bunkRequest);

    // check if they reached the limit and hide the button
    if(card.find('.request').length == limit) {
        $('.add-bunk-request-trigger').hide();
    }
    return false;
});

$('body').on('click', '.bunk-request .remove-bunk-request-trigger', function() {
    var $this = $(this);
    $this.parents('.request').remove();
    $('.add-bunk-request-trigger').show();
    return false;
});

$('body').on('keydown', '.bunk-request .tab-next', function(e) {
    if(e.keyCode === 9) {
        var $this = $(this);
        if($this.parents('.request').is(':last-child')) {
            e.preventDefault();
            var card = $this.parents('.bunk-request');
            card.find('.add-bunk-request-trigger').trigger('click');
            $this.parents('.request').next().find('.focus').focus();
        }
    }       
});


$('body').on('change', '.shirt-size [name="shirt_size"]', function() {
    $(this).parents('form').submit();
});
$('body').on('change', '.transportation [name="to_location"], .transportation [name="from_location"]', function() {
    if (!$('.transportation [name="to_location"]:checked').val() || !$('.transportation [name="from_location"]:checked').val()) {
        return false;
    }
    $(this).parents('form').submit();
});

$('body').on('blur', '.bunk-request input', function() {
    var bunkRequest = $(this).parents('.bunk-request');
    var error = false;

     bunkRequest.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!bunkRequest.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(!error) {
        bunkRequest.find('form').submit();
    }
});


// otc medications
$('body').on('change', '.check-all-otc-medications', function() {
    var $this = $(this);
    if($this.prop('checked')) {
        $('.otc-medication').prop('checked', true);
    } else {
        $('.otc-medication').prop('checked', false);
    }
    
    return false;
});


$('body').on('submit', '.email form, .shirt-size form, .transportation form, .bunk-request form, .otc-medications form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var card = $this.parents('.card');
    card.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!card.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            if (data.notification) {
                addNotification(data.notification.title, data.notification.message, data.notification.icon);
            } else {
                showError('Success', data.message);
            }

            if(data.clear) {
                $this[0].reset();
            }

            if(data.location) {
                window.location.href = data.location;
                return false;
            }
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


// prescription
$('body').on('click', '.add-prescription-trigger', function() {
    var data = $(this).parents('.prescriptions');
    var action = $('.add-prescription form').attr('data-action').replace('{application}', data.attr('data-application'));
    $('.add-prescription form').attr('action', action);

    openModal('.add-prescription');
    return false;
});

$('body').on('click', '.edit-prescription-trigger', function() {
    var data = $(this).parents('.prescription');
    var action = $('.edit-prescription form').attr('data-action').replace('{prescription}', data.attr('data-prescription'));
    $('.edit-prescription form').attr('action', action);

    $('.input-target input').removeClass('required');
    $('.input-target input').addClass('hidden');
    
    $('.edit-prescription [name="name"]').val(data.attr('data-name'));
    $('.edit-prescription [name="dosage"]').val(data.attr('data-dosage'));
    $('.edit-prescription [name="method"]').val(data.attr('data-method'));
    $('.edit-prescription [name="start_date"]').val(data.attr('data-start_date'));
    $('.edit-prescription [name="end_date"]').val(data.attr('data-end_date'));
    $('.edit-prescription [name="controlled_drug"]').prop('checked', data.attr('data-controlled_drug') ? true : false);
    $('.edit-prescription [name="instructions"]').val(data.attr('data-instructions'));
    $('.edit-prescription [name="side_effects"]').val(data.attr('data-side_effects'));
    $('.edit-prescription [name="side_effects_plan"]').val(data.attr('data-side_effects_plan'));
    $('.edit-prescription [name="self_administered"]').prop('checked', data.attr('data-self_administered') ? true : false);
    
    $('.edit-prescription [name="known_allergies"]').prop('checked', data.attr('data-known_allergies') ? true : false);
    if(data.attr('data-known_allergies')) {
        $('.edit-prescription [name="known_allergies_description"]').addClass('required');
        $('.edit-prescription [name="known_allergies_description"]').val(data.attr('data-known_allergies_description'));
        $('.edit-prescription [name="known_allergies_description"]').parents('.input-target').removeClass('hidden');
    }

    $('.edit-prescription [name="medication_reaction"]').prop('checked', data.attr('data-medication_reaction') ? true : false);
    if(data.attr('data-medication_reaction')) {
        $('.edit-prescription [name="medication_reaction_description"]').addClass('required');
        $('.edit-prescription [name="medication_reaction_description"]').val(data.attr('data-medication_reaction_description'));
        $('.edit-prescription [name="medication_reaction_description"]').parents('.input-target').removeClass('hidden');
    }

    $('.edit-prescription [name="medication_interaction"]').prop('checked', data.attr('data-medication_interaction') ? true : false);
    if(data.attr('data-medication_interaction')) {
        $('.edit-prescription [name="medication_interaction_description"]').addClass('required');
        $('.edit-prescription [name="medication_interaction_description"]').val(data.attr('data-medication_interaction_description'));
        $('.edit-prescription [name="medication_interaction_description"]').parents('.input-target').removeClass('hidden');
    }

    $('.edit-prescription [name="auth_first_name"]').val(data.attr('data-auth_first_name'));
    $('.edit-prescription [name="auth_last_name"]').val(data.attr('data-auth_last_name'));
    $('.edit-prescription [name="auth_relationship"]').val(data.attr('data-auth_relationship'));
    $('.edit-prescription [name="auth_administering_method"]').val(data.attr('data-auth_administering_method'));

    $('.edit-prescription input[name="schedules[]"]').prop('checked', false);
    var schedules = JSON.parse(data.attr('data-schedule'));
    $.each(schedules, function(index, schedule) {
        $('.edit-prescription input[name="schedules[]"][value="'+schedule+'"]').prop('checked', true);
    });
        
    openModal('.edit-prescription');
    return false;
});

$('body').on('change', '.prescription .target', function() {
    var $this = $(this);
    var prescription = $this.parents('.prescription');
    if($this.prop('checked')) {
        prescription.find('.input-target[data-target="'+$this.attr('data-target')+'"]').removeClass('hidden');
        prescription.find('.input-target[data-target="'+$this.attr('data-target')+'"] input').addClass('required');
        prescription.find('.input-target[data-target="'+$this.attr('data-target')+'"] input').focus();
    } else {
        prescription.find('.input-target[data-target="'+$this.attr('data-target')+'"]').addClass('hidden');
        prescription.find('.input-target[data-target="'+$this.attr('data-target')+'"] input').removeClass('required');
    }
});

$('body').on('submit', '.add-prescription form, .edit-prescription form', function() {
    var $this = $(this);
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;
    var modal = $this.parents('.modal');
    modal.find('.required').each(function() {
        var input = $(this);

        if(input.attr('type') === 'radio') {
            if(!modal.find('input[name="'+input.attr('name')+'"]:checked').length) {
                error = true;
            }
        }

        if(input.attr('type') === 'checkbox') {
            if(!input.prop('checked')) {
                error = true;
            }
        }

        if(input.val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);

            if(data.location) {
                window.location.href = data.location;
                return false;
            }
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-prescription', function(data) {
    console.log(data);

    if($('.prescription[data-prescription="'+data.prescription+'"]').length) {
        var prescription = $('.prescription[data-prescription="'+data.prescription+'"]');

        prescription.attr('data-prescription', data.prescription);
        prescription.attr('data-application', data.application);
        prescription.attr('data-medication_form', data.medication_form);
        prescription.attr('data-medication_form_name', data.medication_form_name);
        prescription.attr('data-name', data.name);
        prescription.attr('data-dosage', data.dosage);
        prescription.attr('data-method', data.method);
        prescription.attr('data-schedule', JSON.stringify(data.schedule));
        prescription.attr('data-instructions', data.instructions);
        prescription.attr('data-side_effects', data.side_effects);
        prescription.attr('data-side_effects_plan', data.side_effects_plan);
        prescription.attr('data-controlled_drug', data.controlled_drug);
        prescription.attr('data-self_administered', data.self_administered);
        prescription.attr('data-known_allergies', data.known_allergies);
        prescription.attr('data-known_allergies_description', data.known_allergies_description);
        prescription.attr('data-medication_reaction', data.medication_reaction);
        prescription.attr('data-medication_reaction_description', data.medication_reaction_description);
        prescription.attr('data-medication_interaction', data.medication_interaction);
        prescription.attr('data-medication_interaction_description', data.medication_interaction_description);
        prescription.attr('data-start_date', data.start_date_raw);
        prescription.attr('data-end_date', data.end_date_raw);
        prescription.attr('data-auth_first_name', data.auth_first_name);
        prescription.attr('data-auth_last_name', data.auth_last_name);
        prescription.attr('data-auth_relationship', data.auth_relationship);
        prescription.attr('data-auth_administering_method', data.auth_administering_method);

        prescription.find('[data-input="name"]').html(data.name);
        prescription.find('[data-input="dosage"]').html(data.dosage);
        prescription.find('[data-input="method"]').html(data.method);
        prescription.find('[data-input="start_date"]').html(data.start_date);
        prescription.find('[data-input="end_date"]').html(data.end_date);
        prescription.find('[data-input="status"]').html(data.status);
        prescription.find('[data-input="status"]').attr('data-color', data.status_color);
        prescription.find('[data-input="instructions"]').html(data.instructions);
        prescription.find('[data-input="side_effects"]').html(data.side_effects);
        prescription.find('[data-input="side_effects_plan"]').html(data.side_effects_plan);
        prescription.find('[data-input="schedule_parsed"]').html(data.schedule_parsed);

        if(data.medication_form && data.medication_form != '') {
            fileUploaderAddFile(prescription.find('.file-uploader'), data.medication_form_name, data.medication_form);
        } else {
            fileUploaderRemoveFile(prescription.find('.file-uploader'));
            // console.log(prescription.find('.file-uploader').length);
            // console.log(prescription.find('.file-uploader').html());
        }

        return 
    }

    if ($('.prescriptions[data-application="'+data.application+'"]').length) {
        $('.prescriptions .prescriptions-wrapper').append(`<div class="prescription"
            data-prescription="${data.prescription}"
            data-application="${data.application}"
            data-medication_form="${data.medication_form}"
            data-medication_form_name="${data.medication_form_name}"
            data-name="${data.name}"
            data-dosage="${data.dosage}"
            data-method="${data.method}"
            data-schedule='${JSON.stringify(data.schedule)}'
            data-instructions="${data.instructions}"
            data-side_effects="${data.side_effects}"
            data-side_effects_plan="${data.side_effects_plan}"
            data-controlled_drug="${data.controlled_drug ? true : ''}"
            data-self_administered="${data.self_administered ? true : ''}"
            data-known_allergies="${data.known_allergies ? true : ''}"
            data-known_allergies_description="${data.known_allergies_description}"
            data-medication_reaction="${data.medication_reaction ? true : ''}"
            data-medication_reaction_description="${data.medication_reaction_description}"
            data-medication_interaction="${data.medication_interaction ? true : ''}"
            data-medication_interaction_description="${data.medication_interaction_description}"
            data-start_date="${data.start_date_raw}"
            data-end_date="${data.end_date_raw}"
            data-auth_first_name="${data.auth_first_name}"
            data-auth_last_name="${data.auth_last_name}"
            data-auth_relationship="${data.auth_relationship}"
            data-auth_administering_method="${data.auth_administering_method}"
            >
            <div class="meta-wrapper">
                <div class="meta">
                    <h1>
                        <span data-input="name">${data.name}</span>
                        (<span data-input="dosage">${data.dosage}</span> - <span data-input="method">${data.method}</span>)
                    </h1>
                    <h2>
                        <span data-input="start_date">${data.start_date}</span>
                        -
                        <span data-input="end_date">${data.end_date}</span>
                    </h2>
                </div>

                <div class="prescription-status">
                    <span class="status" data-input="status" data-color="${data.status_color}">${data.status}</span>
                </div>
            </div>

            <ul class="details-list table">
                <li>
                    <span class="padding">Instructions</span>
                    <span class="highlight" data-input="instructions" data-color="white">${data.instructions}</span>
                </li>

                <li>
                    <span class="padding">Side Effects</span>
                    <span class="highlight" data-color="white">
                        <em data-input="side_effects">${data.side_effects}</em>
                        <em data-input="side_effects_plan">${data.side_effects_plan}</em>
                    </span>
                </li>

                <li>
                    <span class="padding">Schedule</span>
                    <span class="highlight" data-input="schedule_parsed" data-color="white">${data.schedule_parsed}</span>
                </li>
            </ul>
            
            <div class="file-uploader no-remove" data-url="prescription/${data.prescription}/medication-form" data-file="medication_form">
                <div class="upload-progress">
                    <div class="progress-bar">
                        <div class="current-progress"></div>
                    </div>
                </div>
                
                <div class="file">
                    <div class="meta">
                        <h4>Prescription Authorization</h4>
                        <a href="" class="remove-file icon-trash"></a>
                        <p data-default="Please choose a file">Please choose a file</p>
                    </div>

                    <a href="" class="button select-file">Choose File</a>
                </div>

                <input type="file" data-name="medication_form" accept=".jpg, .jpeg, .png, .gif, .pdf, .doc, .docx">
                <input type="hidden" name="medication_form">
            </div>

            <div class="center-button">
                <a href="" class="margin edit-prescription-trigger" data-color="grey">Edit Prescription</a>
                <a href="prescription/${data.prescription}/download-form" class="margin" data-color="grey" target="_BLANK">Download Form</a>
            </div>
        </div>`);
    }
});